import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_GW3_API_LOGGER_URL,
});

export const postLogger = async (url, data) => {
  await instance.post(url, data);
};
